// extracted by mini-css-extract-plugin
export default {"base":"ForbiddenPage_base__R9-V0","colors":"ForbiddenPage_colors__OIPqJ","lock":"ForbiddenPage_lock__pKUKE","show":"ForbiddenPage_show__ZYkNl"};